import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigAssetLoaderService } from '../config/config-asset-loader.service';
import { OperationResult } from '../model/operation-result.model';
import { Member, Members } from '../model/members.model';
import { NotificationsList, NotificationToBeAddedDto } from './notifications.model';
import { Applications } from '@icullen/api/shared';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  USERS_API_BASE_URL : string;
  NOTIFICATIONS_API_BASE_URL: string;
  MANAGE_USERS_API_BASE_URL: string;
  APPS_API_BASE_URL : string;

  constructor(
    private httpClient: HttpClient,
    private configService : ConfigAssetLoaderService
  ) {
     this.USERS_API_BASE_URL= configService.getConfig().apiBaseUrl+'users/';
     this.NOTIFICATIONS_API_BASE_URL= this.USERS_API_BASE_URL+'notifications';
     this.MANAGE_USERS_API_BASE_URL= configService.getConfig().apiBaseUrl+'users/manageUsers/';
     this.APPS_API_BASE_URL= configService.getConfig().apiBaseUrl+'applications/user/access';
  }


  getNotifications(): Observable<NotificationsList> {
    return this.httpClient.get<NotificationsList>(this.NOTIFICATIONS_API_BASE_URL);
  }

  addNotification(notificaitonToBeAdded : NotificationToBeAddedDto):Observable<OperationResult>{
    return this.httpClient.post<OperationResult>(this.NOTIFICATIONS_API_BASE_URL,notificaitonToBeAdded);
  }

  deleteNotification(id : number):Observable<OperationResult>{
    return this.httpClient.delete<OperationResult>(this.NOTIFICATIONS_API_BASE_URL+'/'+id);
  }

  updateProfile(email: string, firstname: string, lastname: string): Observable<OperationResult> {
    return this.httpClient.post<OperationResult>(this.USERS_API_BASE_URL+'updateProfile', {email,firstname,lastname})
  }

  changePassword(password: string): Observable<OperationResult> {
    return this.httpClient.post<OperationResult>(this.USERS_API_BASE_URL+'changePassword', {password})
  }

  getMembers(username : string): Observable<Members> {
    return this.httpClient.get<Members>(this.MANAGE_USERS_API_BASE_URL+username);
  }

  addMember(username : string, member: Member): Observable<OperationResult> {
    return this.httpClient.post<OperationResult>(this.MANAGE_USERS_API_BASE_URL+username+'/addMember',member)
  }

  editMember(member: Member): Observable<OperationResult> {
    return this.httpClient.put<OperationResult>(this.MANAGE_USERS_API_BASE_URL+'editMember',member)
  }

  enableMember(username : string): Observable<OperationResult> {
    return this.httpClient.put<OperationResult>(this.MANAGE_USERS_API_BASE_URL+'enableMember/'+username,{})
  }

  disableMember(username : string): Observable<OperationResult> {
    return this.httpClient.put<OperationResult>(this.MANAGE_USERS_API_BASE_URL+'disableMember/'+username,{})
  }

  getApplications(): Observable<Applications> {
    return this.httpClient.get<Applications>(this.APPS_API_BASE_URL);
  }

}
